<template>
  <div
    class="text-center"
    style="display: none"
  >
    <v-dialog
      attach=".map"
      v-model="dialog"
      persistent
      width="900"
      eager
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >{{ $i18n.t('dashboard.map.uldk') }}</v-card-title>
        <v-card-text style="min-height: 60vh">
          <v-row no-gutters class="pt-3">
            <v-col md="4" class="pr-2">
              <span v-if="isSearchingActive">
                <v-list
                  v-bar
                  two-line
                >
                  <v-list-item-group
                    v-model="selectedParcel"
                    color="primary"
                    class="parcels__item"
                  >
                    <v-list-item
                      v-for="{precint, number, id} in parcels"
                      :key="id"
                    >
                      <v-list-item-content @click="zoomToOfferById(id)">
                        <v-list-item-title>{{$i18n.t(`dashboard.offers.precint`)}} {{ precint }}, {{$i18n.t(`dashboard.parcels.parcel`)}} nr {{ number }}</v-list-item-title>
                        <v-list-item-subtitle v-text="id" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <span class="d-flex justify-space-between">
                  <v-btn
                    :disabled="!currentParcelId || selectedParcel == undefined"
                    color="primary"
                    text
                    @click="addUldkParcel"
                  >{{ $i18n.t('default.add') }}</v-btn>
                  <v-btn
                    v-if="loading"
                    color="primary"
                    text
                    @click="cancelSearching"
                  >{{ $i18n.t('default.cancel') }}</v-btn>
                  <v-btn
                    v-else
                    color="primary"
                    text
                    @click="resetSearching"
                  >{{ $i18n.t('default.back') }}</v-btn>
                </span>
              </span>
              <span v-else>
                <v-select
                  v-model="uldkSearchType"
                  :items="uldkSearchTypeItems"
                  item-text="text"
                  item-value="value"
                  :label="$i18n.t('dashboard.offers.uldkSearchType')"
                  :menu-props="{ offsetY: true }"
                  outlined
                  :rules="[rules.required]"
                />
                <template v-if="uldkSearchType === 'id'">
                  <v-form ref="uldkIdSeachForm" v-model="isUldkIdSearchValid">
                    <v-text-field
                      :label="$i18n.t('dashboard.offers.uldkParcelId')"
                      v-model="uldkParcelId"
                      outlined
                      :rules="[rules.required]"
                    />
                  </v-form>
                  <span class="d-flex justify-space-between">
                    <v-btn
                      color="primary"
                      text
                      :disabled="!isUldkIdSearchValid"
                      @click="searchUldk"
                    >
                      {{ $i18n.t('default.search') }}
                    </v-btn>
                  </span>
                </template>
                <template v-if="uldkSearchType === 'name'">
                  <v-form ref="form" v-model="isUldkNameSearchValid">
                    <v-select
                      :attach="true"
                      v-model="woj"
                      :items="provinces"
                      item-text="jpt_nazwa_"
                      item-value="jpt_kod_je"
                      @change="getPRG('counties')"
                      :label="$i18n.t('dashboard.offers.woj')"
                      :no-data-text="$i18n.t('default.noDataText')"
                      outlined
                      :rules="[rules.required]"
                    />
                    <v-select
                      :attach="true"
                      v-model="powiat"
                      :items="counties"
                      item-text="jpt_nazwa_"
                      item-value="jpt_kod_je"
                      @change="getPRG('communes')"
                      :label="$i18n.t('dashboard.offers.pow')"
                      :no-data-text="$i18n.t('default.noDataText')"
                      outlined
                      :disabled="!woj"
                      :rules="[rules.required]"
                    />
                    <v-select
                      :attach="true"
                      v-model="gmina"
                      :items="communes"
                      :label="$i18n.t('dashboard.offers.gmi')"
                      outlined
                      item-value="jpt_kod_je"
                      :disabled="!powiat"
                      item-text="jpt_nazwa_"
                      @change="getPRG('regions')"
                      :no-data-text="$i18n.t('default.noDataText')"
                      :rules="[rules.required]"
                    />
                    <v-autocomplete
                      :items="regions"
                      :label="`${$i18n.t('dashboard.offers.precint')}`"
                      :no-data-text="`${$i18n.t('default.noDataText')}`"
                      v-model="region"
                      item-value="jpt_kod_je"
                      item-text="jpt_nazwa_"
                      outlined
                      :disabled="!gmina"
                    />
                    <v-text-field
                      :label="`${$i18n.t('dashboard.offers.number')}`"
                      v-model="number"
                      outlined
                      :rules="[rules.required]"
                    />
                    <span class="d-flex justify-space-between">
                      <v-btn
                        color="primary"
                        text
                        :disabled="!isUldkNameSearchValid"
                        @click="searchUldk"
                      >{{ $i18n.t('default.search') }}</v-btn>
                      <v-btn
                        color="primary"
                        text
                        :disabled="!woj && !powiat && !gmina"
                        @click="resetForm"
                      >{{ $i18n.t('default.reset') }}</v-btn>
                    </span>
                  </v-form>
                </template>
              </span>
            </v-col>
            <v-col md="8" class="pl-2">
              <div
                id="parcelsMapCopy"
                :class="{ loading: loading }"
                ref="map"
              >
                <v-progress-circular
                  class="map__loader"
                  color="primary"
                  :width="7"
                  v-if="loading"
                  indeterminate
                  size="64"
                />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="primary"
            text
            @click="cancelUldk"
          >{{ $i18n.t('dialog.confirmation.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Map from 'ol/Map';
import { defaults as defaultControls, ScaleLine } from 'ol/control.js';
import { WKT, GeoJSON } from 'ol/format';
import centroid from '@turf/centroid';
import booleanWithin from '@turf/boolean-within';
import pointOnFeature from '@turf/point-on-feature';

export default {
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    parentMap: {
      required: true,
      validator: function(value) {
        return value === undefined || value instanceof Map;
      }
    }
  },
  data() {
    return {
      currentParcelId: 0,
      isSearchingActive: false,
      loading: false,
      map: undefined,
      number: undefined,
      rules: {
        required: value => !!value || this.$i18n.t('default.requiredField')
      },
      selectedParcel: undefined,
      parcels: [],
      selectedRow: undefined,
      voivodeship: undefined,

      // select arrays

      // PRG

      provinces: [],
      counties: [],
      communes: [],
      regions: [],

      woj: undefined,
      powiat: undefined,
      region: undefined,
      gmina: undefined,
      timeoutID: undefined,
      isUldkNameSearchValid: false,
      isUldkIdSearchValid: false,
      uldkParcelId: '',
      uldkSearchType: '',
    };
  },
  computed: {
    uldkSearchTypeItems() {
      return [
        {
          text: this.$i18n.t('dashboard.offers.fullParcelId'),
          value: 'id'
        },
        {
          text: this.$i18n.t('dashboard.offers.precintNameAndParcelNumber'),
          value: 'name'
        }
      ];
    }
  },
  watch: {
    woj(newVal) {
      if (newVal) {
        this.gmina = undefined;
        this.powiat = undefined;
      }
    },
    powiat(newVal) {
      if (newVal) {
        this.gmina = undefined;
      }
    },
    uldkSearchType(nV) {
      if (nV === 'id' && this.$refs.form) {
        this.$refs.form.reset();
      } else if (nV === 'name' && this.$refs.uldkIdSeachForm) {
        this.$refs.uldkIdSeachForm.reset();
      }
    }
  },

  methods: {
    addUldkParcel() {
      const layer = this.getLayerByName('polygonDrawLayer');
      const features = layer.getSource().getFeatures();
      const nonSelectedFeatures = features.filter(
        f => f.get('id') !== this.currentParcelId
      );
      nonSelectedFeatures.forEach(f => {
        layer.getSource().removeFeature(f);
      });
      this.$emit('uldkAdded');
    },
    cancelUldk() {
      this.loading = false;
      clearTimeout(this.timeoutID);
      this.$emit('cancelUldk');
      this.resetSearching();
    },
    getLayerByName(name) {
      return this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get('name') == name;
        });
    },
    getPRG(level) {
      const woj = this.woj ? this.woj : null;
      const pow = this.powiat ? this.powiat : null;
      const gmi = this.gmina ? this.gmina : null;
      let payload = {
        level,
        params: {
          woj,
          pow,
          gmi
        }
      };
      if (woj) {
        this.$store.dispatch('getPRG', payload).then(r => {
          if (r.status === 200) {
            this[level] = r.data[level];
          }
        });
      }
    },
    cancelSearching() {
      this.loading = false;
      this.zoomToFoundParcels();
      clearTimeout(this.timeoutID);
    },
    resetForm() {
      this.$refs.form.reset();
    },
    resetSearching() {
      this.loading = false;
      this.isSearchingActive = false;
      clearTimeout(this.timeoutID);
      this.selectedParcel = undefined;
      this.parcels = [];
      this.getLayerByName('polygonDrawLayer')
        .getSource()
        .clear();
    },
    getParcel(payload) {
      // payloads is array of objects containing precint (region) and number
      let counter = 0;
      const action = () => {
        if (counter < payload.length) {
          this.timeoutID = setTimeout(() => {
            this.$store
              .dispatch('getParcelUldkByID', payload[counter])
              .then(r => {
                if (r.status === 200) {
                  this.loading = false;
                  if (r.data.slice(0, 2) === '-1') {
                    this.$root.$emit(
                      'showSnackbar',
                      this.$i18n.t('dashboard.map.parcelNotFound')
                    );
                  } else {
                    this.isSearchingActive = true;
                    //every parcel in new line
                    const parcelData = r.data.split('\n').slice(1, -1);
                    parcelData.forEach(parcel => {
                      if (!parcel.includes('SRID')) {
                        // sometimes SRID is missing - add default SRID (2180)
                        parcel = `SRID=2180;${parcel}`;
                      }

                      const [epsg, parcelData] = parcel.split(';');
                      const [
                        wkt,
                        voivodeship,
                        county,
                        commune,
                        number,
                        region,
                        teryt
                      ] = parcelData.split('|');
                      const parcelFeature = new WKT({}).readFeature(wkt, {
                        dataProjection: `EPSG:${epsg.split('=')[1]}`,
                        featureProjection: 'EPSG:3857'
                      });
                      parcelFeature.set(
                        'wojewodztwo',
                        voivodeship.toLocaleLowerCase()
                      );
                      parcelFeature.set('gmina', commune);
                      parcelFeature.set('powiat', county);
                      parcelFeature.set('nr_ew_dzialek', number);
                      parcelFeature.set('nr_obre', region);
                      parcelFeature.set('teryt', teryt.trim());
                      parcelFeature.set(
                        'wsp_geogr',
                        this.getParcelCentroid(parcelFeature).join(', ')
                      );
                      parcelFeature.set('id', teryt.trim());
                      this.getLayerByName('polygonDrawLayer')
                        .getSource()
                        .addFeature(parcelFeature);
                      this.parcels.push({
                        precint: region,
                        number: number,
                        id: teryt.trim()
                      });
                      this.$emit('changeBaselayer', 'HereStreets');
                    });
                  }
                } else {
                  this.loading = false;
                  this.$root.$emit(
                    'showSnackbar',
                    this.$i18n.t('dashboard.map.parcelError' + r.data)
                  );
                }
              });
            counter++;
            if (counter === payload.length) {
              this.zoomToFoundParcels();
              this.loading = false;
            }
            action();
          }, 1000);
        }
      };
      return action;
    },
    zoomToFoundParcels() {
      this.map.getView().fit(
        this.getLayerByName('polygonDrawLayer')
          .getSource()
          .getExtent(),
        { duration: 1000, maxZoom: 18 }
      );
    },
    getParcelCentroid(parcel) {
      const geoJSONFeature = JSON.parse(
        new GeoJSON().writeFeature(parcel, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857'
        })
      );
      let parcelCentroid = centroid(geoJSONFeature);
      if (!booleanWithin(parcelCentroid, geoJSONFeature)) {
        parcelCentroid = pointOnFeature(geoJSONFeature);
      }
      return parcelCentroid.geometry.coordinates;
    },
    searchUldk() {
      this.resetSearching();
      this.loading = true;
      if (this.uldkSearchType === 'id') {
        const parcel = this.getParcel([
          { id: this.uldkParcelId }
        ]);
        parcel();
      } else {
        if (this.region && this.number) {
          const parcel = this.getParcel([
            {
              precint: this.region,
              number: this.number
            }
          ]);
          parcel();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('parcels.noPrecint'));
          if (this.regions.length) {
            let payload = this.regions.map(region => {
              return {
                precint: region.jpt_kod_je,
                number: this.number
              };
            });
            const parcel = this.getParcel(payload);
            parcel();
          } else {
            this.resetForm();
            this.loading = false;
            this.resetSearching();
            this.$root.$emit(
              'showSnackbar',
              this.$i18n.t('parcels.noPrecints')
            );
          }
        }
      }
    },
    zoomToFeature(feature) {
      this.map.getView().fit(feature.getGeometry().getExtent(), {
        duration: 1000
      });
    },
    zoomToOfferById(id) {
      const feature = this.getLayerByName('polygonDrawLayer')
        .getSource()
        .getFeatures()
        .find(f => f.get('id') === id);
      this.currentParcelId = id;
      this.zoomToFeature(feature);
    }
  },
  mounted() {
    this.map = new Map({
      layers: this.parentMap.getLayers(),
      target: 'parcelsMapCopy',
      view: this.parentMap.getView(),
      controls: defaultControls().extend([new ScaleLine()])
    });
    this.$store
      .dispatch('getPRG', {
        level: 'provinces'
      })
      .then(r => {
        this.provinces = r.data.provinces;
      });
  }
};
</script>

<style scoped>
.map__loader {
  position: absolute;
  z-index: 1;
  left: 60%;
  top: 40%;
  z-index: 100;
}
.loading {
  opacity: 0.5;
}
#parcelsMapCopy {
  height: 60vh;
  width: auto;
}
.parcels__item {
  max-height: 400px;
  overflow-y: auto;
}
</style>
